import React, { memo } from 'react';
import { Box, useTheme, useMediaQuery } from "@mui/material";
import DataTable from "./DataTable";
import DataCard from "./DataCard";
import Loader from "../custom-component/Loader";

// columnsLoading: the table's column config (useTableColumns isLoading) hasn't arrived yet, so there
// is nothing to draw - show the loader in the table's place instead of an empty, column-less table.
const DataContainer = ({ columnsLoading = false, ...props }) => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('md'));

	if (columnsLoading) {
		return (
			<Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
				<Loader variant="dots" message="Loading." />
			</Box>
		);
	}

	if (isMobile) {
		return <DataCard {...props} />;
	}

	return <DataTable {...props} />;
};

export default memo(DataContainer);
